<template>
  <!-- element-loading-text="excle导入中，请稍等" -->
  <div class="app-container">
    <!-- 编辑弹框 -->
    <el-dialog
      :fullscreen="true"
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="100%"
    >
      <el-form
        ref="addForm"
        label-position="right"
        :model="addForm"
        :rules="rules"
        label-width="100px"
      >
        <el-form-item label="id" prop="_id" v-if="addForm._id">
          <el-input v-model="addForm._id" :disabled="!!addForm._id"></el-input>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="addForm.title"></el-input>
        </el-form-item>
        <el-form-item label="二级标题" prop="subTitle">
          <el-input v-model="addForm.subTitle"></el-input>
        </el-form-item>
        <el-form-item label="显示顺序" prop="order">
          <el-input-number
            v-model="addForm.order"
            :min="1"
            :max="10002"
            label="越大排名越前"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="标签" prop="tag">
          <el-input v-model="addForm.tag"></el-input>
        </el-form-item>
        <el-form-item label="是否显示" prop="isShow">
          <el-switch
            v-model="addForm.isShow"
            active-text="显示"
            inactive-text="不显示"
          ></el-switch>
        </el-form-item>
        <el-form-item label="作者" prop="author">
          <el-input v-model="addForm.author"></el-input>
        </el-form-item>
        <el-form-item label="发布时间" prop="publishTime">
          <el-date-picker
            v-model="addForm.publishTime"
            type="datetime"
            placeholder="选择日期时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="文章内容" prop="content">
          <vue-editor
            height="500"
            useCustomImageHandler
            :customModules="customModulesForEditor"
            @image-added="handleImageAdded"
            :editorOptions="editorSettings"
            v-model="addForm.content"
          />
        </el-form-item>

        <el-form-item label="图片上传">
          <el-upload
            class="upload-demo"
            :action="picbaseurl"
            :on-remove="handleRemove"
            :file-list="fileList2"
            :on-success="handleUpload"
            list-type="picture"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，且不超过500kb
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogConfirmButtonClick('addForm')"
          >确 定</el-button
        >
        <el-button type="primary" @click="dialogVisible = false"
          >取 消</el-button
        >
      </div>
    </el-dialog>

    <el-card
      class="box-card"
      v-loading="loading"
      element-loading-spinner="el-icon-loading"
    >
      <div slot="header" class="clearfix">
        <el-button
          type="primary"
          size="mini"
          icon="el-icon-circle-plus-outline"
          round
          :style="{ float: 'right', marginTop: '10px' }"
          @click="addItem"
          >新增</el-button
        >
      </div>
      <div class="content">
        <el-table :data="tdata" border style="width: 100%">
          <el-table-column
            type="index"
            width="50"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="title"
            label="标题"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="author"
            label="作者"
            align="center"
          ></el-table-column>
          <el-table-column prop="isHot" label="首页显示" align="center">
            <template slot-scope="scope">
              {{ scope.row.isHot ? "显示" : "不显示" }}
            </template>
          </el-table-column>
          <el-table-column
            prop="publishTime"
            label="发布时间"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="tag"
            label="标签"
            align="center"
          ></el-table-column>
          <el-table-column prop="name" label="封面图" align="center">
            <template slot-scope="scope">
              <img :src="scope.row.cover" width="100" alt />
            </template>
          </el-table-column>

          <el-table-column
            fixed="right"
            label="操作"
            width="220"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                @click="handleEdit(scope.row)"
                size="mini"
                >编辑</el-button
              >
              <el-button
                type="danger"
                @click="handleDelete(scope.row)"
                size="mini"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import { ImageDrop } from "quill-image-drop-module";
import ImageResize from "quill-image-resize-module";
import imgmix from "../../mixins/editor_up";

import * as api from "../../api/share.api";
export default {
  mixins: [imgmix],
  data() {
    return {
      dialogVisible: false,
      dialogTitle: "新增",
      formLabelWidth: "200",
      editorContent: "",
      fileList2: [],
      editorSettings: {
        modules: {
          imageDrop: true,
          imageResize: {},
        },
      },
      customModulesForEditor: [
        { alias: "imageDrop", module: ImageDrop },
        { alias: "imageResize", module: ImageResize },
      ],

      defaultForm: {
        title: null,
        subTitle: null,
        author: null,
        isHot: true,
        isShow: true,
        publishTime: new Date(),
        content: "",
        tag: "",
        order: 1,
        cover: "",
      },
      addForm: {},
      loading: false,
      rules: {
        title: [
          {
            required: true,
            message: "请完善信息",
            trigger: "blur",
          },
        ],
        content: [
          {
            required: true,
            message: "请完善信息",
            trigger: "blur",
          },
        ],
      },
      tdata: [],
    };
  },
  components: {
    VueEditor,
  },
  created() {
    this.initData();
  },
  mounted() {},
  computed: {},
  methods: {
    handleUpload(file, fileList) {
      this.fileList2.push({
        name: file.data,
        url: file.data,
      });
      if (this.fileList2.length > 0) {
        this.addForm.cover = this.fileList2[0].url;
      }
    },
    handleRemove(file, fileList) {
      this.fileList2 = this.fileList2.filter((v) => v.url != file.url);
    },
    addItem() {
      this.dialogVisible = true;
      this.dialogTitle = "新增";
      this.addForm = this.defaultForm;
    },
    handleEdit(item) {
      this.dialogVisible = true;
      this.dialogTitle = "修改";
      this.addForm = item;
      if (item.cover) {
        this.fileList2 = [
          {
            name: item.cover,
            url: item.cover,
          },
        ];
      }
    },
    dialogConfirmButtonClick(formName) {
      if (this.fileList2.length > 0) {
        this.addForm.cover = this.fileList2[0].url;
      } else {
        this.addForm.cover = "";
      }
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return this.$message.error("请检查填写信息是否完整");
        }
        if (this.addForm._id) {
          this.httpPost("/backend/news/upd", this.addForm).then((resp) => {
            this.addForm = this.defaultForm;
            this.fileList2 = [];
            if (resp.code == 0) {
              this.$message.success("修改成功", 1000);
              this.initData();
              this.dialogVisible = false;
            } else {
              this.$message.error(resp.msg, 2000);
            }
          });
        } else {
          this.httpPost("/backend/news/add", this.addForm).then((resp) => {
            this.addForm = this.defaultForm;
            this.fileList2 = [];
            if (resp.code == 0) {
              this.$message.success("添加成功", 1000);
              this.initData();
              this.dialogVisible = false;
            } else {
              this.$message.error(resp.msg, 2000);
            }
          });
        }
      });
    },
    initData() {
      this.loading = true;
      this.httpPost("/backend/news", {}).then((resp) => {
        console.log(resp);
        this.loading = false;
        this.tdata = resp.data;
      });
    },

    onEditSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        console.log(valid);
        if (valid) {
          api.updateShareDataById(this.form).then((resp) => {
            if (resp.rCode != 0) {
              this.$message.error(resp.msg);
            } else {
              this.dialogVisible = false;
              this.form = {};
              this.$message.success("修改成功");
              this.initData();
            }
          });
          console.log(this.form);
        } else {
          this.$message.error("请检查填写信息是否完整");
          return false;
        }
      });
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handleSizeblur(size) {
      this.pquery.size = size;
    },
    handleCurrentblur(page) {
      this.pquery.page = page;
    },
    handleClick(row) {
      this.form = row;
      this.dialogVisible = true;
    },
    handleDelete(row) {
      this.$confirm("请再次确认是否删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          this.httpPost("/backend/news/del", { _id: row._id }).then((resp) => {
            if (resp.code != 0) {
              this.$message.error("删除失败");
            } else {
              this.initData();
              this.$message.success("删除成功");
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>

<style scoped>
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
.cell {
  text-align: center;
}
</style>
